import { render, staticRenderFns } from "./ordermanagementwarehousing.vue?vue&type=template&id=26fe62cf&"
import script from "./ordermanagementwarehousing.vue?vue&type=script&lang=ts&"
export * from "./ordermanagementwarehousing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordermanagementwarehousing.vue"
export default component.exports